"use client";

import type { ReactNode } from "react";
import Image from "next/image";

type PublicBookingLayoutProps = {
  children: ReactNode;
};

export function PublicBookingLayout({ children }: PublicBookingLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="space-y-4">
        {/* Company Logo Header */}
        <div className="flex justify-center pt-4 sm:pt-6 pb-2 px-4">
          <div className="bg-card rounded-lg shadow-sm p-3 sm:p-4 border border-gray-200 max-w-sm sm:max-w-none dark:border-gray-700">
            <Image
              src="/logo_long.svg"
              alt="West Tennessee Consulting"
              width={200}
              height={64}
              className="h-10 w-auto sm:h-12 md:h-16"
              priority
            />
          </div>
        </div>

        {/* Main Content with better mobile spacing */}
        <div className="px-2 sm:px-4">{children}</div>

        {/* Subtle UnifiedTime logo at bottom - responsive */}
        <div className="flex justify-center pb-4 px-4">
          <div className="opacity-20 hover:opacity-40 transition-opacity">
            <Image
              src="/unifiedtime.png"
              alt="UnifiedTime"
              width={120}
              height={24}
              className="h-4 w-auto sm:h-5 md:h-6"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
